/**
 * Include your custom JavaScript here.
 */

(function () {
  function initSweetSpotTicker() {
    var ticker = document.querySelector('.ss-marquee');
    if (!ticker || ticker.dataset.tickerInitialized === 'true') return;
    ticker.dataset.tickerInitialized = 'true';

    var group = [
      '<div class="ss-marquee-group">',
      '<span>Fair Play <b aria-hidden="true"></b></span>',
      '<span>Organic Cotton <b aria-hidden="true"></b></span>',
      '<span>Made for good vibes <b aria-hidden="true"></b></span>',
      '<span>Tennis is therapy <b aria-hidden="true"></b></span>',
      '</div>'
    ].join('');

    ticker.innerHTML = '<div class="ss-marquee-track">' +
      group +
      group.replace('<div ', '<div aria-hidden="true" ') +
      group.replace('<div ', '<div aria-hidden="true" ') +
      group.replace('<div ', '<div aria-hidden="true" ') +
      group.replace('<div ', '<div aria-hidden="true" ') +
      group.replace('<div ', '<div aria-hidden="true" ') +
      '</div>';
  }

  function initSweetSpotIntroStyles() {
    if (document.getElementById('ss-intro-reference-styles')) return;
    var style = document.createElement('style');
    style.id = 'ss-intro-reference-styles';
    style.textContent = [
      '.ss-section.ss-intro{width:100%!important;max-width:none!important;margin:0!important;padding:105px 0!important;background:#faf5eb!important;color:#181817!important;text-align:center!important}',
      '.ss-intro-wrap{width:min(calc(100% - 40px),1440px)!important;margin-inline:auto!important}',
      '.ss-intro-eyebrow{margin:0 0 18px!important;font-family:Arial,Helvetica,sans-serif!important;font-size:.72rem!important;font-weight:800!important;line-height:1.2!important;letter-spacing:.16em!important;text-transform:uppercase!important}',
      '.ss-intro-title{margin:0!important;font-family:Arial,Helvetica,sans-serif!important;font-size:clamp(2.25rem,4.5vw,5rem)!important;font-weight:700!important;line-height:.92!important;letter-spacing:-.055em!important;text-transform:none!important}',
      '.ss-intro-copy{max-width:850px!important;margin:28px auto 0!important;font-family:Arial,Helvetica,sans-serif!important;font-size:clamp(1.15rem,2vw,1.75rem)!important;font-weight:400!important;line-height:1.35!important;letter-spacing:0!important}',
      '@media(max-width:640px){.ss-section.ss-intro{padding:76px 0!important}.ss-intro-eyebrow{margin-bottom:14px!important;font-size:.66rem!important}.ss-intro-title{font-size:clamp(2.25rem,12vw,3.4rem)!important}.ss-intro-copy{margin-top:22px!important;font-size:1.12rem!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initSweetSpotIntro() {
    var intro = document.querySelector('.ss-section.ss-intro');
    if (!intro || intro.dataset.referenceInitialized === 'true') return;
    intro.dataset.referenceInitialized = 'true';
    intro.innerHTML = [
      '<div class="ss-intro-wrap">',
      '<div class="ss-intro-eyebrow">Welcome to the club</div>',
      '<h2 class="ss-intro-title">Tenniswear.<br>Without the dress code.</h2>',
      '<p class="ss-intro-copy">Sweet Spot steht für Sport, Haltung und Stil. Unsere Pieces bringen die Energie des Tennisplatzes in deinen Alltag, ohne steif, elitär oder vorhersehbar zu sein.</p>',
      '</div>'
    ].join('');
  }

  function initSweetSpotHome() {
    initSweetSpotIntroStyles();
    initSweetSpotTicker();
    initSweetSpotIntro();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSweetSpotHome);
  else initSweetSpotHome();
  document.addEventListener('shopify:section:load', initSweetSpotHome);
}());

/* Swatches: event-driven only. */
(function () {
  var scheduled = false;

  function normalize(value) {
    return String(value || '').trim().toLocaleLowerCase('de-DE').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ');
  }

  function readCssString(name) {
    var value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!value) return '';
    try { return JSON.parse(value); } catch (error) { return value.replace(/^["']|["']$/g, ''); }
  }

  function getSwatchMap() {
    var map = { weiss: '#ffffff', white: '#ffffff' };
    var source = window.theme && typeof window.theme.ssSwatchMap === 'string' ? window.theme.ssSwatchMap : readCssString('--ss-swatch-map');
    String(source || '').split(/[\n,]+/).forEach(function (entry) {
      var separator = entry.indexOf(':');
      if (separator < 1) return;
      var name = normalize(entry.slice(0, separator));
      var color = entry.slice(separator + 1).trim();
      if (name && color) map[name] = color;
    });
    return map;
  }

  function applyCorrectSwatches(scope) {
    scheduled = false;
    var map = getSwatchMap();
    (scope || document).querySelectorAll('.ss-product-color[title], .ProductItem__ColorSwatchList .ColorSwatch').forEach(function (swatch) {
      var label = swatch.getAttribute('title') || swatch.getAttribute('data-tooltip') || '';
      var color = map[normalize(label)];
      if (!color) return;
      if (swatch.dataset.ssAppliedColor === color) return;
      swatch.dataset.ssAppliedColor = color;
      swatch.style.setProperty('background-image', 'none', 'important');
      swatch.style.setProperty('background', color, 'important');
      swatch.style.setProperty('background-color', color, 'important');
    });
  }

  function scheduleApply(scope) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { applyCorrectSwatches(scope || document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scheduleApply(document); });
  else scheduleApply(document);

  document.addEventListener('shopify:section:load', function (event) { scheduleApply(event.target); });
  document.addEventListener('ss:quick-view:rendered', function (event) { scheduleApply(event.target || document); });
}());

/* Product page variant buttons. Prestige remains the source of truth. */
(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').trim().toLocaleLowerCase('de-DE').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ');
  }

  function readCssString(name) {
    var value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!value) return '';
    try { return JSON.parse(value); } catch (error) { return value.replace(/^["']|["']$/g, ''); }
  }

  function getSwatchMap() {
    /* Always support German/English white. Theme values override defaults. */
    var map = { weiss: '#ffffff', white: '#ffffff' };
    var source = window.theme && typeof window.theme.ssSwatchMap === 'string' ? window.theme.ssSwatchMap : readCssString('--ss-swatch-map');
    String(source || '').split(/[\n,]+/).forEach(function (entry) {
      var separator = entry.indexOf(':');
      if (separator < 1) return;
      var name = normalize(entry.slice(0, separator));
      var color = entry.slice(separator + 1).trim();
      if (name && color) map[name] = color;
    });
    return map;
  }

  function getFallbackColor() {
    return readCssString('--ss-swatch-fallback') || '#d8d8d8';
  }

  function isColorOption(label) {
    return ['farbe', 'color', 'colour', 'couleur', 'colore'].indexOf(normalize(label)) !== -1;
  }

  function addStyles() {
    if (document.getElementById('ss-product-variant-button-styles')) return;
    var style = document.createElement('style');
    style.id = 'ss-product-variant-button-styles';
    style.textContent = [
      '.template-product .ProductForm__Option--ss-buttons>.ProductForm__Item{display:none!important}',
      '.template-product .SSVariantSelector{margin:0 0 18px}',
      '.template-product .SSVariantSelector__Label{margin:0 0 9px;color:#171714;font-size:12px;font-weight:600;line-height:1.3}',
      '.template-product .SSVariantSelector__Choices{display:flex;flex-wrap:wrap;gap:10px 16px}',
      '.template-product .SSVariantButton{display:inline-flex;align-items:center;justify-content:center;min-width:48px;min-height:42px;padding:8px 14px;border:1px solid rgba(23,23,20,.28);background:transparent;color:#171714;font:inherit;font-size:12px;font-weight:500;line-height:1;cursor:pointer;transition:border-color .18s ease,background .18s ease,color .18s ease}',
      '.template-product .SSVariantButton:hover{border-color:#171714}',
      '.template-product .SSVariantButton.is-selected{border-color:#171714;background:#171714;color:#fff}',
      '.template-product .SSVariantButton:focus-visible{outline:2px solid #171714;outline-offset:2px}',
      '.template-product .SSVariantButton--swatch{width:auto!important;height:36px!important;min-width:0!important;min-height:36px!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;color:#171714!important;gap:8px!important;justify-content:flex-start!important}',
      '.template-product .SSVariantButton--swatch.is-selected{background:transparent!important;color:#171714!important}',
      '.template-product .SSVariantButton__Swatch{display:block;flex:0 0 30px;width:30px;height:30px;border-radius:50%;border:1px solid rgba(23,23,20,.18);background:var(--ss-variant-swatch-color)!important;box-sizing:border-box;box-shadow:none}',
      '.template-product .SSVariantButton--swatch.is-white .SSVariantButton__Swatch{border-color:#9f9f99!important}',
      '.template-product .SSVariantButton--swatch:hover .SSVariantButton__Swatch{box-shadow:0 0 0 1px rgba(23,23,20,.5)}',
      '.template-product .SSVariantButton--swatch.is-selected .SSVariantButton__Swatch{box-shadow:0 0 0 2px #faf5eb,0 0 0 3px #171714}',
      '.template-product .SSVariantButton__Text{display:block;color:#171714;font-size:12px;font-weight:500;line-height:1.2;white-space:nowrap}',
      '@media(max-width:640px){.template-product .SSVariantButton:not(.SSVariantButton--swatch){min-width:44px;min-height:40px;padding:8px 12px}.template-product .SSVariantButton--swatch{height:34px!important;min-height:34px!important}.template-product .SSVariantButton__Swatch{flex-basis:28px;width:28px;height:28px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getOptionData(optionElement) {
    var trigger = optionElement.querySelector('.ProductForm__Item');
    if (!trigger) return null;
    var popoverId = trigger.getAttribute('aria-controls');
    if (!popoverId) return null;
    var selector = document.getElementById(popoverId);
    if (!selector) return null;
    var values = Array.prototype.slice.call(selector.querySelectorAll('[data-action="select-value"]'));
    if (!values.length) return null;
    var optionName = trigger.querySelector('.ProductForm__OptionName');
    var label = optionName ? optionName.textContent.split(':')[0].trim() : '';
    if (!label) {
      var popoverTitle = selector.querySelector('.Popover__Title');
      label = popoverTitle ? popoverTitle.textContent.trim() : '';
    }
    return { trigger: trigger, selector: selector, values: values, label: label };
  }

  function syncButtons(optionElement, data) {
    var selectedValue = data.trigger.querySelector('.ProductForm__SelectedValue');
    var current = selectedValue ? selectedValue.textContent.trim() : '';
    optionElement.querySelectorAll('.SSVariantButton').forEach(function (button) {
      var isSelected = button.getAttribute('data-value') === current;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function buildButtons(optionElement) {
    if (optionElement.dataset.ssVariantButtonsInitialized === 'true') return;
    var data = getOptionData(optionElement);
    if (!data) return;

    optionElement.dataset.ssVariantButtonsInitialized = 'true';
    optionElement.classList.add('ProductForm__Option--ss-buttons');
    var group = document.createElement('div');
    group.className = 'SSVariantSelector';

    if (data.label) {
      var label = document.createElement('div');
      label.className = 'SSVariantSelector__Label';
      label.textContent = data.label;
      group.appendChild(label);
    }

    var choices = document.createElement('div');
    choices.className = 'SSVariantSelector__Choices';
    choices.setAttribute('role', 'group');
    if (data.label) choices.setAttribute('aria-label', data.label);

    var swatchMap = getSwatchMap();
    var fallbackColor = getFallbackColor();
    var colorOption = isColorOption(data.label);

    data.values.forEach(function (sourceButton) {
      var value = sourceButton.getAttribute('data-value') || sourceButton.textContent.trim();
      var normalizedValue = normalize(value);
      var swatchColor = colorOption ? (swatchMap[normalizedValue] || fallbackColor) : '';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'SSVariantButton';
      button.setAttribute('data-value', value);
      button.setAttribute('aria-pressed', 'false');

      if (colorOption) {
        button.classList.add('SSVariantButton--swatch');
        if (normalizedValue === 'weiss' || normalizedValue === 'white' || /^(#fff|#ffffff|white)$/i.test(String(swatchColor).replace(/\s+/g, ''))) {
          button.classList.add('is-white');
        }
        button.setAttribute('aria-label', value);
        button.setAttribute('title', value);

        var swatch = document.createElement('span');
        swatch.className = 'SSVariantButton__Swatch';
        swatch.setAttribute('aria-hidden', 'true');
        swatch.style.setProperty('--ss-variant-swatch-color', swatchColor);
        button.appendChild(swatch);

        var text = document.createElement('span');
        text.className = 'SSVariantButton__Text';
        text.textContent = value;
        button.appendChild(text);
      } else {
        button.textContent = value;
      }

      button.addEventListener('click', function () {
        sourceButton.click();
        window.requestAnimationFrame(function () { syncButtons(optionElement, data); });
      });
      choices.appendChild(button);
    });

    group.appendChild(choices);
    optionElement.appendChild(group);
    syncButtons(optionElement, data);

    var selectedValue = data.trigger.querySelector('.ProductForm__SelectedValue');
    if (selectedValue) {
      new MutationObserver(function () { syncButtons(optionElement, data); }).observe(selectedValue, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function init(scope) {
    addStyles();
    var root = scope || document;
    root.querySelectorAll('.ProductForm__Option').forEach(buildButtons);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.setTimeout(function () { init(document); }, 0); });
  else window.setTimeout(function () { init(document); }, 0);

  document.addEventListener('shopify:section:load', function (event) { window.setTimeout(function () { init(event.target); }, 0); });
}());
